/* Updated: 2026-09-29 10:20 BST — Fetch fresh HMAC from Hub /challenge before submit; no Shopify native fallback (lost tickets). */
/* Updated: 2026-06-18 14:00 UTC+1 — Hub contact form flow + country mismatch alert + location pickers + PDP sidebar */

(function () {
  var ORDER_PANEL_CATEGORIES = { order: true, returns: true, warranty: true };
  var GEO_CACHE_KEY = 'gohub_contact_geo_detail';
  var COUNTRY_ALIASES = { UK: 'GB', GBR: 'GB', USA: 'US', UNITEDKINGDOM: 'GB', UNITEDSTATES: 'US' };

  function decodeEntities(str) {
    if (!str || typeof str !== 'string' || str.indexOf('&') === -1) return str;
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  function decodeCopyObject(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    Object.keys(obj).forEach(function (key) {
      if (typeof obj[key] === 'string') {
        obj[key] = decodeEntities(obj[key]);
      } else if (obj[key] && typeof obj[key] === 'object') {
        decodeCopyObject(obj[key]);
      }
    });
    return obj;
  }

  function readCachedGeo() {
    try {
      var raw = sessionStorage.getItem(GEO_CACHE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function cacheGeo(geo) {
    try {
      sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify(geo));
    } catch (e) { /* noop */ }
  }

  function fetchGeoDetails() {
    return fetch('https://ipapi.co/json/', { cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data) return null;
        return {
          country_code: String(data.country_code || data.country || '').trim(),
          country_name: String(data.country_name || '').trim(),
          region: String(data.region || data.region_code || '').trim(),
          city: String(data.city || '').trim()
        };
      })
      .catch(function () { return null; });
  }

  function formatGeoLocation(geo) {
    if (!geo) return '';
    return [geo.city, geo.region, geo.country_name || geo.country_code]
      .filter(Boolean)
      .join(', ');
  }

  function formatGeoCountry(geo) {
    if (!geo) return '';
    return [geo.country_name, geo.country_code ? '(' + geo.country_code + ')' : '']
      .filter(Boolean)
      .join(' ');
  }

  function formatGeoCity(geo) {
    if (!geo) return '';
    if (window.GOHUB_CONTACT_LOCATION && window.GOHUB_CONTACT_LOCATION.normalizeGeoCity) {
      return window.GOHUB_CONTACT_LOCATION.normalizeGeoCity(geo.city, geo.region, geo.country_code) || geo.region || '';
    }
    return geo.city || geo.region || '';
  }

  function readCopy(formUid) {
    var node = document.querySelector('[data-gohub-contact-copy="' + formUid + '"]');
    if (!node) return {};
    try {
      return decodeCopyObject(JSON.parse(node.textContent || '{}'));
    } catch (e) {
      return {};
    }
  }

  function readMarketsMap(formUid) {
    var node = document.querySelector('[data-gohub-markets-map="' + formUid + '"]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function normalizeCountryCode(code) {
    var normalized = String(code || '').trim().toUpperCase().replace(/[^A-Z]/g, '');
    if (!normalized) return '';
    if (COUNTRY_ALIASES[normalized]) return COUNTRY_ALIASES[normalized];
    if (normalized.length > 2) return COUNTRY_ALIASES[normalized] || normalized.slice(0, 2);
    return normalized;
  }

  function substitute(template, vars) {
    if (!template) return '';
    return template.replace(/\{\{(\w+)\}\}/g, function (_, key) {
      return vars[key] != null ? vars[key] : '';
    });
  }

  function normalizeMarketPath(path) {
    var value = String(path || '/').trim() || '/';
    if (value !== '/' && value.charAt(value.length - 1) !== '/') {
      value += '/';
    }
    return value;
  }

  function buildSwitchUrl(currentPath, currentMarketPath, targetMarketPath) {
    var path = currentPath || window.location.pathname || '/';
    var from = normalizeMarketPath(currentMarketPath);
    var to = normalizeMarketPath(targetMarketPath);
    var lowerPath = path.toLowerCase();

    if (from !== '/' && lowerPath.indexOf(from.toLowerCase()) === 0) {
      return to + path.slice(from.length).replace(/^\//, '');
    }

    var clean = path.replace(/^\//, '');
    if (to === '/') return '/' + clean;
    return to + clean;
  }

  function ContactFlow(root) {
    this.root = root;
    this.formUid = root.getAttribute('data-gohub-block-id') || '';
    this.copy = readCopy(this.formUid);
    this.marketsMap = readMarketsMap(this.formUid);
    this.categorySelect = root.querySelector('[data-gohub-field="category"]');
    this.flow = root.querySelector('[data-gohub-contact-flow]');
    this.hint = root.querySelector('[data-gohub-category-hint]');
    this.orderPanel = root.querySelector('[data-gohub-panel="order_reference"]');
    this.messageLabel = root.querySelector('[data-gohub-message-label]');
    this.submitLabel = root.querySelector('[data-gohub-submit-label]');
    this.form = root.closest('form');
    this.geo = readCachedGeo() || {};
    this.geoPromise = null;
    this.locationPickers = null;
    this.bind();
    this.initLocationPickers();
    this.renderContextPanel();
    this.prefetchGeo();
    this.bindLocationPreview();
  }

  ContactFlow.prototype.bindLocationPreview = function () {
    var self = this;
    this.root.addEventListener('gohub-location-update', function () {
      self.updateLocationPreview();
    });
  };

  ContactFlow.prototype.updateLocationPreview = function () {
    var previewEl = this.root.querySelector('[data-gohub-location-preview]');
    if (!previewEl) return;

    var unavailable = this.root.getAttribute('data-gohub-context-geo-unavailable') || 'Unavailable';
    var loading = this.root.getAttribute('data-gohub-context-geo-loading') || 'Detecting…';
    var parts = [];

    if (this.locationPickers) {
      var country = this.locationPickers.getCountryLabel();
      var state = this.locationPickers.getState();
      var city = this.locationPickers.getCity();
      if (country) parts.push(country);
      if (state) parts.push(state);
      if (city) parts.push(city);
    }

    if (parts.length) {
      previewEl.textContent = parts.join(' · ');
      return;
    }

    previewEl.textContent = this.geoPromise ? loading : unavailable;
  };

  ContactFlow.prototype.initLocationPickers = function () {
    if (!window.GohubContactLocation) return;
    this.locationPickers = window.GohubContactLocation.init(this.root, this.copy);
  };

  ContactFlow.prototype.renderContextPanel = function () {
    var marketEl = this.root.querySelector('[data-gohub-context-market]');
    var shopCountryEl = this.root.querySelector('[data-gohub-context-shop-country]');
    var geoCountryEl = this.root.querySelector('[data-gohub-context-geo-country]');
    var geoCityEl = this.root.querySelector('[data-gohub-context-geo-city]');
    if (!marketEl && !shopCountryEl && !geoCountryEl && !geoCityEl) return;

    var unavailable = this.root.getAttribute('data-gohub-context-geo-unavailable') || 'Unavailable';
    var loading = this.root.getAttribute('data-gohub-context-geo-loading') || 'Detecting…';

    var marketSite = this.root.getAttribute('data-gohub-market-site') || '';
    var marketPath = this.root.getAttribute('data-gohub-market-path') || '';
    var marketLocale = this.root.getAttribute('data-gohub-market-locale') || '';
    if (marketEl) {
      var marketText = marketSite || '—';
      if (marketPath) marketText += ' (' + marketPath + ')';
      if (marketLocale) marketText += ' · ' + marketLocale;
      marketEl.textContent = marketText;
    }

    var shopCountryName = this.root.getAttribute('data-gohub-shop-country-name') || '';
    var shopCountryCode = this.root.getAttribute('data-gohub-shop-country-code') || '';
    if (shopCountryEl) {
      shopCountryEl.textContent = [shopCountryName, shopCountryCode ? '(' + shopCountryCode + ')' : '']
        .filter(Boolean)
        .join(' ') || '—';
    }

    var geo = this.geo || {};
    var countryText = formatGeoCountry(geo);
    var cityText = formatGeoCity(geo);

    if (geoCountryEl) {
      geoCountryEl.textContent = countryText || (this.geoPromise ? loading : unavailable);
    }
    if (geoCityEl) {
      geoCityEl.textContent = cityText || (this.geoPromise ? loading : unavailable);
    }

    this.prefillDetailsFromGeo();
    this.renderContextPreview();
    this.updateLocationPreview();
    this.renderCountryMismatchAlert();
  };

  ContactFlow.prototype.renderContextPreview = function () {
    var previewEl = this.root.querySelector('[data-gohub-context-preview]');
    if (!previewEl) return;

    var unavailable = this.root.getAttribute('data-gohub-context-geo-unavailable') || 'Unavailable';
    var loading = this.root.getAttribute('data-gohub-context-geo-loading') || 'Detecting…';
    var market = this.root.getAttribute('data-gohub-market') || '';
    var marketLabels = { catalog: 'Catalog', uk: 'UK', us: 'US' };
    var marketSite = this.root.getAttribute('data-gohub-market-site') || '';
    var marketShort = marketLabels[market] || (marketSite ? marketSite.split('(')[0].trim() : '');
    var geo = this.geo || {};
    var countryShort = geo.country_name || geo.country_code || '';
    var cityText = formatGeoCity(geo);
    var parts = [];

    if (marketShort) parts.push(marketShort);
    if (countryShort) parts.push(countryShort);
    if (cityText) parts.push(cityText);

    if (parts.length) {
      previewEl.textContent = parts.join(' · ');
      return;
    }

    previewEl.textContent = this.geoPromise ? loading : unavailable;
  };

  ContactFlow.prototype.renderCountryMismatchAlert = function () {
    var alertEl = this.root.querySelector('[data-gohub-country-mismatch]');
    if (!alertEl) return;

    var isSidebar = this.root.getAttribute('data-gohub-layout') === 'sidebar';
    var alertClass = 'alert alert--info gohub-contact__country-alert-inner'
      + (isSidebar ? ' gohub-contact__country-alert-inner--sidebar' : '');

    var geo = this.geo || {};
    var geoCode = normalizeCountryCode(geo.country_code);
    var shopCode = normalizeCountryCode(this.root.getAttribute('data-gohub-shop-country-code') || '');
    var market = this.root.getAttribute('data-gohub-market') || '';
    var isCatalog = market === 'catalog';
    var mismatchCopy = this.copy.country_mismatch || {};
    var shopCountryName = this.root.getAttribute('data-gohub-shop-country-name') || shopCode || 'your country';

    if (isCatalog) {
      if (!geoCode) {
        alertEl.hidden = true;
        alertEl.innerHTML = '';
        return;
      }

      if (geoCode === 'GB' || geoCode === 'US') {
        var catalogRecommended = this.marketsMap[geoCode];
        if (!catalogRecommended || !catalogRecommended.path) {
          alertEl.hidden = true;
          alertEl.innerHTML = '';
          return;
        }

        var catalogGeoCountry = geo.country_name || geoCode;
        var catalogRecommendedSite = catalogRecommended.label || catalogGeoCountry;
        var catalogSwitchUrl = buildSwitchUrl(
          window.location.pathname,
          this.root.getAttribute('data-gohub-market-path') || '/',
          catalogRecommended.path
        );
        var catalogIntro = substitute(mismatchCopy.catalog_regional_intro, {
          geo_country: catalogGeoCountry
        });
        var catalogPrefix = substitute(mismatchCopy.catalog_regional_action, {
          geo_country: catalogGeoCountry,
          recommended_site: catalogRecommendedSite
        });
        var catalogLinkText = substitute(mismatchCopy.catalog_link, {
          recommended_site: catalogRecommendedSite
        });

        if (isSidebar) {
          alertEl.innerHTML =
            '<div class="' + alertClass + '">' +
              '<p class="gohub-contact__country-alert-intro">' + catalogIntro + ' ' + catalogPrefix +
              ' <a href="' + catalogSwitchUrl + '">' + catalogLinkText + '</a>.</p>' +
            '</div>';
        } else {
          alertEl.innerHTML =
            '<div class="' + alertClass + '">' +
              '<p class="gohub-contact__country-alert-intro">' + catalogIntro + '</p>' +
              '<p class="gohub-contact__country-alert-action">' + catalogPrefix + ' <a href="' + catalogSwitchUrl + '">' + catalogLinkText + '</a>.</p>' +
            '</div>';
        }
        alertEl.hidden = false;
        return;
      }

      var catalogIntro = substitute(mismatchCopy.catalog_intro, {
        shop_country: shopCountryName
      });

      alertEl.innerHTML =
        '<div class="' + alertClass + '">' +
          '<p class="gohub-contact__country-alert-intro">' + catalogIntro + '</p>' +
        '</div>';
      alertEl.hidden = false;
      return;
    }

    if (!geoCode || !shopCode || geoCode === shopCode) {
      alertEl.hidden = true;
      alertEl.innerHTML = '';
      return;
    }

    var recommended = this.marketsMap[geoCode];
    if (!recommended || !recommended.path) {
      alertEl.hidden = true;
      alertEl.innerHTML = '';
      return;
    }

    var geoCountry = geo.country_name || geoCode;
    var recommendedSite = recommended.label || geoCountry;
    var switchUrl = buildSwitchUrl(
      window.location.pathname,
      this.root.getAttribute('data-gohub-market-path') || '/',
      recommended.path
    );
    var vars = {
      shop_site: shopCountryName,
      geo_country: geoCountry,
      recommended_site: recommendedSite
    };

    var intro = substitute(mismatchCopy.intro, vars);
    var vpn = mismatchCopy.vpn || 'If you\'re using a VPN, try turning it off';
    var linkText = substitute(mismatchCopy.link || 'load the {{recommended_site}} site', vars);
    var actionLine = vpn + ', <a href="' + switchUrl + '">' + linkText + '</a>.';

    if (isSidebar) {
      alertEl.innerHTML =
        '<div class="' + alertClass + '">' +
          '<p class="gohub-contact__country-alert-intro">' + intro + ' ' + actionLine + '</p>' +
        '</div>';
    } else {
      alertEl.innerHTML =
        '<div class="' + alertClass + '">' +
          '<p class="gohub-contact__country-alert-intro">' + intro + '</p>' +
          '<p class="gohub-contact__country-alert-action">' + actionLine + '</p>' +
        '</div>';
    }
    alertEl.hidden = false;
  };

  ContactFlow.prototype.prefillDetailsFromGeo = function () {
    if (this.locationPickers) {
      this.locationPickers.prefillFromGeo(this.geo || {});
    }
  };

  ContactFlow.prototype.prefetchGeo = function () {
    if (this.geo && (this.geo.city || this.geo.region || this.geo.country_code)) {
      this.renderContextPanel();
      return;
    }
    var self = this;
    this.geoPromise = fetchGeoDetails().then(function (geo) {
      if (geo) {
        self.geo = geo;
        cacheGeo(geo);
      }
      self.geoPromise = null;
      self.renderContextPanel();
      return self.geo;
    });
  };

  ContactFlow.prototype.ensureGeo = function () {
    if (this.geo && (this.geo.city || this.geo.region || this.geo.country_code)) {
      return Promise.resolve(this.geo);
    }
    if (this.geoPromise) return this.geoPromise;
    this.prefetchGeo();
    return this.geoPromise || Promise.resolve(this.geo || {});
  };

  ContactFlow.prototype.bind = function () {
    var self = this;
    if (!this.categorySelect || !this.flow) return;

    var defaultCategory = this.root.getAttribute('data-gohub-default-category') || '';
    if (defaultCategory && !this.categorySelect.value) {
      this.categorySelect.value = defaultCategory;
    }

    this.categorySelect.addEventListener('change', function () {
      self.applyCategory(self.categorySelect.value);
    });

    if (this.categorySelect.value) {
      this.applyCategory(this.categorySelect.value);
    }

    if (this.form) {
      this.form.addEventListener('submit', function (ev) {
        self.handleSubmit(ev);
      });
    }
  };

  ContactFlow.prototype.applyCategory = function (category) {
    if (!category) {
      this.flow.hidden = true;
      return;
    }

    this.flow.hidden = false;

    var isSidebar = this.root.getAttribute('data-gohub-layout') === 'sidebar';
    var isPageProduct = this.root.getAttribute('data-gohub-page-product') === 'true';

    if (this.hint) {
      var hint = '';
      if (isSidebar && this.copy.hints_sidebar) {
        hint = this.copy.hints_sidebar[category] || '';
        if (category === 'product' && isPageProduct) {
          hint = this.copy.hints_sidebar.product || '';
        }
      }
      if (!hint && this.copy.hints) {
        hint = this.copy.hints[category] || '';
      }
      this.hint.textContent = hint;
      this.hint.hidden = !hint;
    }

    if (this.orderPanel) {
      this.orderPanel.hidden = !ORDER_PANEL_CATEGORIES[category];
    }

    if (this.messageLabel && this.copy.message_labels) {
      var msgLabel = this.copy.message_labels[category] || this.messageLabel.textContent;
      if (isSidebar && this.copy.message_labels_sidebar && this.copy.message_labels_sidebar[category]) {
        msgLabel = this.copy.message_labels_sidebar[category];
      }
      this.messageLabel.textContent = msgLabel;
    }

    if (this.submitLabel && this.copy.submit_labels) {
      var submitText = this.copy.submit_labels[category] || this.submitLabel.textContent;
      if (isSidebar && this.copy.submit_labels_sidebar) {
        submitText = this.copy.submit_labels_sidebar[category]
          || this.copy.submit_labels_sidebar.general
          || submitText;
      }
      this.submitLabel.textContent = submitText;
    }
  };

  ContactFlow.prototype.readField = function (name) {
    var el = this.root.querySelector('[data-gohub-field="' + name + '"]');
    return el ? (el.value || '').trim() : '';
  };

  ContactFlow.prototype.readHoneypot = function () {
    var el = this.root.querySelector('[data-gohub-honeypot]');
    return el ? (el.value || '') : '';
  };

  ContactFlow.prototype.buildContextLines = function () {
    var lines = [];
    var marketSite = this.root.getAttribute('data-gohub-market-site') || '';
    var marketPath = this.root.getAttribute('data-gohub-market-path') || '';
    if (marketSite) {
      lines.push('Store/market: ' + marketSite + (marketPath ? ' (' + marketPath + ')' : ''));
    }

    var shopCountryName = this.root.getAttribute('data-gohub-shop-country-name') || '';
    var shopCountryCode = this.root.getAttribute('data-gohub-shop-country-code') || '';
    if (shopCountryName || shopCountryCode) {
      lines.push('Shop country: ' + [shopCountryName, shopCountryCode ? '(' + shopCountryCode + ')' : ''].filter(Boolean).join(' '));
    }

    var marketLocale = this.root.getAttribute('data-gohub-market-locale') || '';
    if (marketLocale) {
      lines.push('Site language: ' + marketLocale);
    }

    var visitorCountryCode = this.readField('visitor_country');
    var visitorCountryLabel = this.locationPickers
      ? this.locationPickers.getCountryLabel()
      : visitorCountryCode;
    var visitorState = this.readField('visitor_state');
    var visitorCity = this.readField('visitor_city');
    if (visitorCountryCode) {
      lines.push('Your country: ' + [visitorCountryLabel, '(' + visitorCountryCode + ')'].filter(Boolean).join(' '));
    }
    if (visitorState) {
      lines.push('Your state: ' + visitorState);
    }
    if (visitorCity) {
      lines.push('Your city: ' + visitorCity);
    }

    return lines.length ? lines.join('\n') + '\n\n' : '';
  };

  ContactFlow.prototype.buildMessage = function () {
    var message = this.readField('message');
    var orderRef = this.readField('order_reference');
    var prefix = this.buildContextLines();
    if (orderRef) {
      message = 'Order/reference: ' + orderRef + '\n\n' + message;
    }
    return prefix + message;
  };

  ContactFlow.prototype.buildPayload = function (category) {
    var geo = this.geo || {};
    var visitorCountryCode = this.readField('visitor_country');
    var visitorCountryName = this.locationPickers ? this.locationPickers.getCountryLabel() : '';
    var visitorState = this.readField('visitor_state');
    var visitorCity = this.readField('visitor_city');
    return {
      block_id: this.root.getAttribute('data-gohub-block-id') || '',
      product_id: this.root.getAttribute('data-gohub-product-id') || '',
      product_handle: this.root.getAttribute('data-gohub-product-handle') || '',
      product_title: this.root.getAttribute('data-gohub-product-title') || '',
      variant_sku: this.root.getAttribute('data-gohub-variant-sku') || '',
      variant_id: this.root.getAttribute('data-gohub-variant-id') || '',
      market: this.root.getAttribute('data-gohub-market') || '',
      market_site: this.root.getAttribute('data-gohub-market-site') || '',
      market_path: this.root.getAttribute('data-gohub-market-path') || '',
      market_locale: this.root.getAttribute('data-gohub-market-locale') || '',
      shop_country_code: this.root.getAttribute('data-gohub-shop-country-code') || '',
      shop_country_name: this.root.getAttribute('data-gohub-shop-country-name') || '',
      geo_country_code: geo.country_code || '',
      geo_country_name: geo.country_name || '',
      geo_region: geo.region || '',
      geo_city: geo.city || '',
      geo_location: formatGeoLocation(geo),
      visitor_country: visitorCountryCode,
      visitor_country_name: visitorCountryName,
      visitor_state: visitorState,
      visitor_city: visitorCity,
      currency: this.root.getAttribute('data-gohub-currency') || '',
      shopify_customer_id: this.root.getAttribute('data-gohub-customer-id') || '',
      page_url: window.location.href,
      referrer_url: document.referrer || '',
      timestamp: this.root.getAttribute('data-gohub-timestamp') || '',
      token: this.root.getAttribute('data-gohub-token') || '',
      name: this.readField('name'),
      email: this.readField('email'),
      category: category,
      message: this.buildMessage(),
      website_url: this.readHoneypot()
    };
  };

  ContactFlow.prototype.challengeUrl = function () {
    var endpoint = (this.root.getAttribute('data-gohub-endpoint') || '').replace(/\/$/, '');
    return endpoint ? endpoint + '/challenge' : '';
  };

  ContactFlow.prototype.fetchHubChallenge = function () {
    var url = this.challengeUrl();
    if (!url) return Promise.reject(new Error('no_challenge_url'));
    var blockId = this.root.getAttribute('data-gohub-block-id') || '';
    var productId = this.root.getAttribute('data-gohub-product-id') || '';
    if (!productId) productId = '0';
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ block_id: blockId, product_id: productId })
    }).then(function (res) {
      if (!res.ok) throw new Error('challenge_' + res.status);
      return res.json();
    });
  };

  ContactFlow.prototype.submitToHub = function (category) {
    var endpoint = this.root.getAttribute('data-gohub-endpoint') || '';
    // var fallback = this.root.getAttribute('data-gohub-fallback') !== 'false';
    var payload = this.buildPayload(category);
    var btn = this.form.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');

    var self = this;
    this.fetchHubChallenge().then(function (challenge) {
      if (challenge && challenge.timestamp) payload.timestamp = String(challenge.timestamp);
      if (challenge && challenge.token) payload.token = String(challenge.token);
      return fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    }).then(function (res) {
      if (res.ok) return res.json().catch(function () { return {}; });
      throw new Error('hub_' + res.status);
    }).then(function (data) {
      var msg = self.root.querySelector('[data-gohub-field="message"]');
      if (msg) msg.value = '';
      var success = document.createElement('div');
      success.className = 'field field--full';
      var refStr = data && data.reference ? ' (Ref: ' + data.reference + ')' : '';
      success.innerHTML = '<div class="alert alert--success" role="status">Thanks — we received your message' + refStr + '. We\'ll be in touch by email.</div>';
      self.root.insertBefore(success, self.root.firstChild);
      if (btn) btn.removeAttribute('disabled');
    }).catch(function (err) {
      console.warn('[gohub-contact] Hub POST failed:', err && err.message);
      // 2026-09-29: Do not fall back to Shopify native contact — staff get email but Hub gets no ticket.
      // if (fallback) {
      //   try { self.form.submit(); } catch (e) { /* noop */ }
      // } else {
      if (btn) btn.removeAttribute('disabled');
      var fail = document.createElement('div');
      fail.className = 'field field--full';
      fail.innerHTML = '<div class="alert alert--error" role="alert">Sorry — we couldn\'t send your message right now. Please try again shortly.</div>';
      self.root.insertBefore(fail, self.root.firstChild);
      // }
    });
  };

  ContactFlow.prototype.handleSubmit = function (ev) {
    var ready = this.root.getAttribute('data-gohub-ready') === 'true';
    var endpoint = this.root.getAttribute('data-gohub-endpoint') || '';
    if (!ready || !endpoint) return;

    ev.preventDefault();

    if (this.locationPickers && !this.locationPickers.validate()) {
      var existing = this.root.querySelector('[data-gohub-location-error]');
      if (existing) existing.remove();
      var fail = document.createElement('div');
      fail.className = 'field field--full';
      fail.setAttribute('data-gohub-location-error', '');
      var msg = (this.copy && this.copy.location_required) || 'Please select your country and city/state from the lists.';
      fail.innerHTML = '<div class="alert alert--error" role="alert">' + msg + '</div>';
      var details = this.root.querySelector('.gohub-contact__details');
      if (details) details.insertAdjacentElement('afterend', fail);
      else this.root.insertBefore(fail, this.root.firstChild);
      return;
    }

    var category = this.readField('category') || 'general';
    var self = this;
    this.ensureGeo().then(function () {
      self.submitToHub(category);
    });
  };

  function initFlows() {
    document.querySelectorAll('[data-gohub-contact-form]').forEach(function (root) {
      if (root.__gohubFlowInit) return;
      root.__gohubFlowInit = true;
      new ContactFlow(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlows);
  } else {
    initFlows();
  }
})();
